import classNames from "classnames";
import { map } from "lodash-es";
import Link from "next/link";
import * as React from "react";
import { paths } from "@libs/paths";
import styles from "./index.module.css";

type Props = {
  shopUuid: string;
  current?: "top" | "shopMatch" | "shopPhoto";
  className?: string;
};

const Tab: React.FC<Props> = ({ shopUuid, current = "top", className }) => {
  const tabs = {
    top: {
      url: paths.shopDetail(shopUuid),
      label: "トップ",
      isActive: current === "top",
    },
    shopMatch: {
      url: paths.shopMatches(shopUuid),
      label: "上映予定",
      isActive: current === "shopMatch",
    },
    shopPhoto: {
      url: paths.shopPhoto(shopUuid),
      label: "写真",
      isActive: current === "shopPhoto",
    },
  };
  return (
    <div className={classNames(className, styles.tab, styles.tabs)}>
      <div className={styles.inner}>
        {map(tabs, (data, tab) => (
          <div
            key={tab}
            className={classNames(
              styles.items,
              data.isActive && styles.isActive
            )}
          >
            <Link href={data.url}>{data.label}</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tab;
